(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form-with-text-info"] && !Shopify.designMode) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  const form = document.getElementById("ContactForm");
  const message = document.getElementById("form-message");

  const forminit = new Forminit();
  const FORM_ID = form.dataset.formId;

  function postLeadToSFDC() {

    const requestOptions = {
      method: 'POST',
      mode: 'no-cors',
    };

    const oid = "00DHp000003SrwL";
    const retUrl = "http://test";
    const lead_source = "Web";
    const webform_submitted_from = ""; //00NOJ000002yxQr
    const lead_assignment_rule = ""; //00NOJ000004FyhW
    const sales_rep_code = ""; //00NOJ000007uBPl
    const first_name = document.querySelector('[name="fi-sender-firstName"]').value;
    const last_name = document.querySelector('[name="fi-sender-lastName"]').value;
    const company = document.querySelector('[name="fi-text-enterprise"]').value;
    const email = document.querySelector('[name="fi-sender-email"]').value;
    const phone = document.querySelector('[name="fi-text-phone"]').value;
    const description = document.querySelector('[name="fi-text-message"]').value;
    const debugEmail = "dev@kesato.com";

    fetch(
      `https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8&oid=${oid}&retURL=${retUrl}&first_name=${first_name}&last_name=${last_name}&email=${email}&phone=${phone}&description=${description}&00NOJ000007uBPl=${sales_rep_code}&00NOJ000004FyhW=${lead_assignment_rule}&00NOJ000002yxQr=${webform_submitted_from}&lead_source=${lead_source}&debug=1&debugEmail=${debugEmail}`,
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => console.log(result))
      .catch((error) => console.log('error', error));
  }

  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    const formData = new FormData(form);
    const { data, error } = await forminit.submit(FORM_ID, formData);
    postLeadToSFDC();
    if (error) {
      message.innerHTML = document.getElementById('error-banner').innerHTML;
      return;
    }

    message.innerHTML = document.getElementById('success-banner').innerHTML;

    form.reset();
  });

  
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-multistep"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
  const steps = document.querySelectorAll(".form-step");
  const indicators = document.querySelectorAll(".step");
  const nextBtn = document.querySelector(".next-step");
  const contact_steps = document.querySelector(".multi-contact__steps");
  const contact_title = document.querySelector(".multi-contact__title");
  const contact_desc = document.querySelector(".multi-contact__desc");
  const form = document.getElementById("MultiStepForm");
  const success = document.querySelector(".form-success");

  const forminit = new Forminit();
  const FORM_ID = form.dataset.formId;

  let current = 0;

  // ================================
  // VALIDATION STEP 1
  // ================================
  function validateStep1() {
    const step1 = steps[0];
    const fields = step1.querySelectorAll("input, select, textarea");

    let isValid = true;
    let firstInvalid = null;

    fields.forEach((field) => {
      field.classList.remove("form-error");

      if (field.hasAttribute("required")) {
        if (!field.value || field.value.trim() === "") {
          isValid = false;
          field.classList.add("form-error");

          if (!firstInvalid) firstInvalid = field;
        }
      }
    });

    if (!isValid && firstInvalid) {
      firstInvalid.focus();
    }

    return isValid;
  }

  // ================================
  // STEP TRANSITION
  // ================================
  function goToStep(nextIndex) {
    if (nextIndex === current) return;

    // ❌ block forward if step 1 invalid
    if (nextIndex > current && current === 0) {
      if (!validateStep1()) return;
    }

    const currentStep = steps[current];
    const nextStep = steps[nextIndex];

    currentStep.classList.add("exit-left");
    currentStep.classList.remove("active");

    setTimeout(() => {
      currentStep.classList.remove("exit-left");

      nextStep.classList.add("active");

      indicators[current].classList.remove("active");

      indicators[nextIndex].classList.add("active");

      current = nextIndex;
    }, 200);
  }

  // ================================
  // NEXT BUTTON
  // ================================
  if (nextBtn) {
    nextBtn.addEventListener("click", () => {
      goToStep(1);
    });
  }

  // ================================
  // CLICK STEP INDICATORS
  // ================================
  indicators.forEach((indicator, index) => {
    indicator.addEventListener("click", () => {
      // allow going back anytime
      if (index < current) {
        goToStep(index);
      }

      // allow forward ONLY if valid
      if (index > current) {
        if (validateStep1()) {
          goToStep(index);
        }
      }
    });
  });

  // ================================
  // FILE INPUT UI
  // ================================
  const fileInput = form.querySelector('input[type="file"]');

  if (fileInput) {
    fileInput.addEventListener("change", function () {
      const wrapper = this.closest(".upload-box");
      const text = wrapper.querySelector(".text-upload");
      let fileNameEl = wrapper.querySelector(".selected-file-name");

      // No files selected (e.g. user cancelled the dialog): restore default label
      if (this.files.length === 0) {
        if (fileNameEl) fileNameEl.remove();
        if (text) text.style.display = "";
        return;
      }

      const fileNames = Array.from(this.files)
        .map((file) => file.name)
        .join(", ");

      if (!fileNameEl) {
        fileNameEl = document.createElement("div");
        fileNameEl.classList.add("selected-file-name");
        // Insert before the button so the names stay on the left side
        wrapper.insertBefore(fileNameEl, wrapper.querySelector("button"));
      }

      fileNameEl.textContent = fileNames;
      fileNameEl.title = fileNames; // full list on hover if it gets truncated

      if (text) text.style.display = "none";
    });
  }

  // ================================
  // LEADS TO SALESFORCE
  // ================================
  function postLeadToSFDC() {

    const requestOptions = {
      method: 'POST',
      mode: 'no-cors',
    };

    const oid = "00DHp000003SrwL";
    const retUrl = "http://test";
    const lead_source = "Web";
    const lead_submitted_attachments = document.querySelector('[name="fi-file-attachments[]"]').value; //00NOJ000002yxQl
    const webform_submitted_from = ""; //00NOJ000002yxQr
    const lead_assignment_rule = ""; //00NOJ000004FyhW
    const sales_rep_code = ""; //00NOJ000007uBPl
    const typeProject = document.querySelector('[name="fi-select-type"]').value; //00NOJ000002yxQi
    const materials = document.querySelector('[name="fi-select-scope"]').value;  //00NOJ0000092DnC
    const description = document.querySelector('[name="fi-text-description"]').value;
    // const attachment = document.querySelector('[name="fi-file-attachment"]').value;
    const first_name = document.querySelector('[name="fi-sender-firstName"]').value;
    const last_name = document.querySelector('[name="fi-sender-lastName"]').value;
    const email = document.querySelector('[name="fi-sender-email"]').value;
    const phone = document.querySelector('[name="fi-text-phone"]').value;
    const street = document.querySelector('[name="fi-text-address"]').value;
    const city = document.querySelector('[name="fi-text-city"]').value;
    const zip = document.querySelector('[name="fi-text-postal"]').value;
    const debugEmail = "dev@kesato.com";

    fetch(
      `https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8&oid=${oid}&retURL=${retUrl}&first_name=${first_name}&last_name=${last_name}&email=${email}&phone=${phone}&street=${street}&city=${city}&zip=${zip}&description=${description}&00NOJ0000092DnC=${materials}&00NOJ000002yxQi=${typeProject}&00NOJ000007uBPl=${sales_rep_code}&00NOJ000004FyhW=${lead_assignment_rule}&00NOJ000002yxQr=${webform_submitted_from}&00NOJ000002yxQl=${lead_submitted_attachments}&lead_source=${lead_source}&debug=1&debugEmail=${debugEmail}`,
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => console.log(result))
      .catch((error) => console.log('error', error));
  }

  // ================================
  // FORMINIT SUBMIT
  // ================================
  form.addEventListener("submit", async (e) => {
    e.preventDefault();

    const formData = new FormData(form);

    const { data, error } = await forminit.submit(FORM_ID, formData);

    postLeadToSFDC();

    if (error) {
      alert(error.message);
      return;
    }

    steps[current].classList.remove("active");
    steps[current].classList.add("exit-left");

    setTimeout(() => {
      contact_steps.classList.add("exit-left");
      contact_title.classList.add("exit-left");
      contact_desc.classList.add("exit-left");

      steps.forEach(s => s.style.display = "none");

      success.classList.add("active");

      form.reset();

      if (fileInput) {
        const wrapper = fileInput.closest(".upload-box");
        const text = wrapper.querySelector(".text-upload");
        const fileNameEl = wrapper.querySelector(".selected-file-name");

        if (text) text.style.display = "";
        if (fileNameEl) fileNameEl.remove();
      }

    }, 100);
  });

});

  } catch(e) { console.error(e); }
})();
})();
